module.exports = __webpack_public_path__ + "static/media/stretch_icon.8e89e50f.jpg";